<template>
  <div>
    <CreateEditQuestionModal
      v-if="showCreateEditQuestionModal"
      typeQuestion="course"
      :courseId="courseId"
      :questionId="questionIdSelected"
      @closeModal="closedModal"
    />
    <LoadingData v-if="loadData" />
    <div v-else class="card">
      <div class="card-header d-flex align-items-center py-0">
        <h6 class="py-3 mb-0">Questões do Curso</h6>
        <div class="ms-auto">
          <button
            v-if="courseSelected.status == 2"
            type="button"
            class="btn btn-primary"
            title="Cadastrar Questão"
            @click="createEditQuestion()"
          >
            Cadastrar Questão
          </button>
        </div>
      </div>
      <div class="card-body">
        <ListQuestions
          :questions="questions"
          @editQuestion="createEditQuestion"
        />
      </div>
    </div>
  </div>
</template>

<script>
import CreateEditQuestionModal from '@/components/courses/questions/CreateEditQuestionModal.vue'
import LoadingData from '@/components/commons/LoadingData.vue'
import ListQuestions from '@/components/courses/questions/ListQuestions.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'QuestionsCourse',

  components: {
    CreateEditQuestionModal,
    LoadingData,
    ListQuestions,
  },

  props: {
    courseId: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      loadData: true,
      showCreateEditQuestionModal: false,
      questions: [],
      questionIdSelected: null,
    }
  },

  computed: {
    ...mapGetters(['courseSelected']),
  },

  methods: {
    async getQuestions() {
      try {
        this.questions = await this.$store.dispatch('getQuestions', {
          courseId: this.courseId,
        })
        this.loadData = false
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },

    createEditQuestion(questionId) {
      this.questionIdSelected = questionId || null
      this.showCreateEditQuestionModal = true
    },

    closedModal(loadListQuestion) {
      if (loadListQuestion) {
        this.getQuestions()
      }
      this.showCreateEditQuestionModal = false
    },
  },

  mounted() {
    this.getQuestions()
  },
}
</script>
